<template >
  <div
    v-if="inputModel"
  >
    <div
      v-for="(input) in inputObj.templates.inputs"
      class="list-group"
    >
      <label
          :for="inputObj.name + '_' + input.index"
      >
        {{input.title}}
      </label>

      <input
          v-model="inputModel[input.index]"
          :id="inputObj.name + '_' + input.index"
          type="text"
          class="form-control"
      />
    </div>
  </div>


  <!--



    <display-debug>
      <template #debugView>
        inputModel: {{inputModel}}
      </template>
   </display-debug>

    <display-debug>
      <template #debugView>
        inputModel: {{inputModel}}
      </template>

    </display-debug>
    -->
</template>

<script>

export default {
  name: "InvoiceSymbolsInput",
  props: {
    "inputObj": Object,
    "formObj": Object,
    "modelValue": [Object, String, Number],
    "activeLang": {
      type: [String],
      required: false,
      default: null,
    },
  },
  data() {
    return {
      inputModel: null,
      timer: null,
      timer_delay: 500,
    }
  },

  created() {
    console.log('dev InvoiceSymbolsInput created - inputModel', this.inputModel)
    console.log('dev InvoiceSymbolsInput created - inputObj.val', this.inputObj.val)
  },

  mounted() {
    console.log('dev InvoiceSymbolsInput mounted - inputModel', this.inputModel)
    console.log('dev InvoiceSymbolsInput mounted - inputObj.val', this.inputObj.val)

    this.inputModel = {};

    if(
        this.inputObj
        && this.inputObj.val
    ) {
      for(const input in this.inputObj.val) {
        this.inputModel[input] = this.inputObj.val[input];
      }
    }

    if(
        this.inputObj
        && this.inputObj.templates
        && this.inputObj.templates.inputs
    ) {
      for(const input of this.inputObj.templates.inputs) {
          if(typeof this.inputModel[input.index] == "undefined" ) {
            this.inputModel[input.index] = null;
          }
      }
    }
  },
  methods: {

  },
  watch: {
    inputModel: {
      handler(newVal, oldVal) {
        if(typeof oldVal != "undefined") {
          this.inputObj.val = newVal
          this.$emit('update:modelValue', newVal )
        }
      },
      deep: true,
      immediate: true
    },
    'inputObj.val': {
      handler(newVal, oldVal) {
        //
        if(typeof oldVal != "undefined" && newVal) {
          console.log('dev InvoiceSymbolsInput watch - inputObj.val', newVal, oldVal)
          this.inputModel = newVal;
        }
      },
      deep: true,
      immediate: true
    },


  },
};
</script>